import React, {useContext, useState} from "react";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import { GlobalContext } from "../providers/GlobalProvider";
import { CircularProgress } from "@material-ui/core";
import { LeaderboardContext } from "../providers/LeaderboardProvider";
import { useHistory } from "react-router";
import Snackbar from "@material-ui/core/Snackbar";
import MuiAlert from "@material-ui/lab/Alert";
import queryString from "query-string";

import PropTypes from 'prop-types';

import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Topic from "./Topic";

// Generate Order Data
function createData(name, topic, description, problems, links, solved) {
  return { name, topic, description, problems, links, solved };
}

function Alert(props) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

const useStyles = makeStyles((theme) => ({
  container: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  loader: {
    marginTop: theme.spacing(4),
  },
}));
function a11yProps(tag) {
  return {
    id: `simple-tab-${tag}`,
    'aria-controls': `simple-tabpanel-${tag}`,
  };
}
function TabPanel(props) {
  const { children, value, tag, ...other } = props;
  return (
      <div
          role="tabpanel"
          hidden={value !== tag}
          key={`simple-tabpanel-${tag}`}
          aria-labelledby={`simple-tab-${tag}`}
          {...other}
      >
        {value === tag && (
            <div>{children}</div>
        )}
      </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  tag: PropTypes.any.isRequired,
  value: PropTypes.any.isRequired,
};

export default function Challenges(props) {
  const timeout = 1000;
  React.useEffect(() => {
    const timer = setTimeout(() => {
      setWaitLoaded(true);
    }, timeout);
    return () => clearTimeout(timer);
  }, [timeout]);
  const [snackPack, setSnackPack] = React.useState([]);
  const [open, setOpen] = React.useState(false);
  const [messageInfo, setMessageInfo] = React.useState(undefined);
  const [value, setValue] = React.useState(queryString.parse(props.location.search).topic);
  const history = useHistory();

  const handleChange = (e, newValue) => {
    if (!(newValue in valueToTopic)) {
      newValue = 0;
    }
    setValue(valueToTopic[newValue]);
    setTopic(valueToTopic[newValue]);
  };

  React.useEffect(() => {
    if (snackPack.length && !messageInfo) {
      // Set a new snack when we don't have an active one
      setMessageInfo({ ...snackPack[0] });
      setSnackPack((prev) => prev.slice(1));
      setOpen(true);
    } else if (snackPack.length && messageInfo && open) {
      // Close an active snack when a new one is added
      setOpen(false);
    }
  }, [snackPack, messageInfo, open]);
  const addSnack = (message, type) => {
    setSnackPack((prev) => [
      ...prev,
      { message, type, key: new Date().getTime() },
    ]);
  };
  const fileSubmit = (topic, problems) => {
    addSnack(`You successfully submitted the following ${topic} problems: ${problems.join(", ")}`, "success");
  };
  const addSuccess = (name, topic) => {
    addSnack("Your flag for " + topic + " " + name + " was correct!", "success");
  };
  const addFail = (name, topic) => {
    addSnack("Your flag for " + topic + " " + name + " was incorrect!", "error");
  };
  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };

  const handleExited = () => {
    setMessageInfo(undefined);
  };
  const classes = useStyles();
  const topics = useContext(GlobalContext).topics;
  const leaderboardState = useContext(LeaderboardContext);
  const topicsLoaded = leaderboardState.leaderboardLoaded;
  const solved = leaderboardState.solved;
  const [waitLoaded, setWaitLoaded] = useState(false);
  if (!topicsLoaded) {
    return (
      <Container maxWidth="lg" className={classes.container}>
        <Grid container spacing={3} justify={"center"}>
          <CircularProgress />
        </Grid>
      </Container>
    );
  } else if (!waitLoaded) {
    return (
        <Container maxWidth="lg" className={classes.container}>
          <Grid container spacing={3} justify={"center"}>
            <CircularProgress />
          </Grid>
        </Container>
    );
  }

  const rows = [];
  const topicToValue = {};
  const valueToTopic = {};
  valueToTopic[0] = '01-gen-funcs';
  let i = 0;
  for (let name in topics) {
    let c = topics[name];
    valueToTopic[i] = name;
    topicToValue[name] = i++;
    rows.push(
      createData(name, c.name, c.description, c.problems, c.links, solved[name])
    );
  }

  if (!(value in topicToValue)) {
    handleChange(null, 0);
    return <div/>;
  }

  function setTopic(topic) {
    const searchParams = new URLSearchParams();
    searchParams.set("topic", topic);
    history.push(`?${searchParams.toString()}`);
  }
  return (
    <Container maxWidth="lg" className={classes.container}>
      <Grid container spacing={3} justify={"center"}>
        <React.Fragment>
          <Tabs value={topicToValue[value]} onChange={handleChange} aria-label="simple tabs example">
            {rows.map((row, index) => (
              <Tab key={`tab-${row.name}`} label={row.topic} {...a11yProps(index)} />
                ))}
            </Tabs>
          {rows.map((row, index) => (
              <TabPanel key={index} value={topicToValue[value]} tag={index}>
                <Topic
                    key={`topic-${row.name}`}
                    name={row.name}
                    topic={row.topic}
                    description={row.description}
                    problems={row.problems}
                    links={row.links}
                    solved={row.solved}
                    onSubmit={fileSubmit}
                    onSuccess={addSuccess}
                    onFail={addFail}
                />
              </TabPanel>
          ))}
            </React.Fragment>
      </Grid>
      <Snackbar
        key={messageInfo ? messageInfo.key : undefined}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right",
        }}
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        onExited={handleExited}
      >
        <Alert
          onClose={handleClose}
          severity={messageInfo ? messageInfo.type : "error"}
        >
          {messageInfo ? messageInfo.message : undefined}
        </Alert>
      </Snackbar>
    </Container>
  );
}
